import axios from 'axios'

const baseUrl = process.env.OCC_ROOT_URL

const apiCall = ({url, method, ...args}) => new Promise((resolve, reject) => {
  setTimeout(() => {
    return axios.get(baseUrl + url, {withCredentials: true})
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(new Error(error))
      })
  }, 1000)
})

export default apiCall
